import {BaseDomainService} from "../../../infrastructure/domain-services/base-domain-service";
import {FooterFactory} from "./footer.factory";
import {FooterRepository} from "./footer.repository";
import {BaseManagedService} from "../../../infrastructure/domain-services/base-managed-service";
import {DomainRequestManager} from "../../../core/managers/domain-request-manager";

export class FooterDomainService extends BaseDomainService {
  static injectables = [...BaseManagedService.injectables, FooterRepository, FooterFactory, DomainRequestManager, FooterFactory];
}